import {SearchItemType} from "@/models/Enums";

export default class DeleteItemRequest {

    public identifier: string | null = null;

    public type: SearchItemType | null = null;

    public markAsDeleted: boolean = true;
}